"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_DATA = void 0;
const config_1 = require("./config");
exports.COUNTRY_DATA = {
    si: {
        short: config_1.COUNTRY.SI.toLowerCase(),
        long: 'Slovenia',
        locale: 'sl-SI',
        language: 'sl',
        languageLong: 'Slovenian',
        display: 'Slovenija',
        currency: 'EUR',
        timezone: 'Europe/Ljubljana',
        apiCountry: config_1.COUNTRY.SI.toLowerCase(),
    },
    hr: {
        short: config_1.COUNTRY.HR.toLowerCase(),
        long: 'Croatia',
        locale: 'hr-HR',
        language: 'hr',
        languageLong: 'Croatian',
        display: 'Hrvatska',
        currency: 'EUR',
        timezone: 'Europe/Zagreb',
        apiCountry: config_1.COUNTRY.HR.toLowerCase(),
    },
    rs: {
        short: config_1.COUNTRY.RS.toLowerCase(),
        long: 'Serbia',
        locale: 'sr-Latn-RS',
        language: 'sr',
        languageLong: 'Serbian',
        display: 'Srbija',
        currency: 'DIN',
        timezone: 'Europe/Belgrade',
        apiCountry: config_1.COUNTRY.RS.toLowerCase(),
    },
    cz: {
        short: config_1.COUNTRY.CZ.toLowerCase(),
        long: 'Czechia',
        locale: 'cs-CZ',
        language: 'cs',
        languageLong: 'Czech',
        display: 'Česká republika',
        currency: 'CZK',
        timezone: 'Europe/Prague',
        apiCountry: config_1.COUNTRY.CZ.toLowerCase(),
    },
    sk: {
        short: config_1.COUNTRY.SK.toLowerCase(),
        long: 'Slovakia',
        locale: 'sk-SK',
        language: 'sk',
        languageLong: 'Slovak',
        display: 'Slovensko',
        currency: 'EUR',
        timezone: 'Europe/Bratislava',
        apiCountry: config_1.COUNTRY.SK.toLowerCase(),
    },
    ro: {
        short: config_1.COUNTRY.RO.toLowerCase(),
        long: 'Romania',
        locale: 'ro-RO',
        language: 'ro',
        languageLong: 'Romanian',
        display: 'Română',
        currency: 'RON',
        timezone: 'Europe/Bucharest',
        apiCountry: config_1.COUNTRY.RO.toLowerCase(),
    },
    bg: {
        short: config_1.COUNTRY.BG.toLowerCase(),
        long: 'Bulgaria',
        locale: 'bg-BG',
        language: 'bg',
        languageLong: 'Bulgarian',
        display: 'България',
        currency: 'BGN',
        timezone: 'Europe/Sofia',
        apiCountry: config_1.COUNTRY.BG.toLowerCase(),
    },
    it: {
        short: config_1.COUNTRY.IT.toLowerCase(),
        long: 'Italy',
        locale: 'it-IT',
        language: 'it',
        languageLong: 'Italian',
        display: 'Italia',
        currency: 'EUR',
        timezone: 'Europe/Rome',
        apiCountry: config_1.COUNTRY.IT.toLowerCase(),
    },
    de: {
        short: config_1.COUNTRY.DE.toLowerCase(),
        long: 'Germany',
        locale: 'de-DE',
        language: 'de',
        languageLong: 'German',
        display: 'Deutschland',
        currency: 'EUR',
        timezone: 'Europe/Berlin',
        apiCountry: config_1.COUNTRY.DE.toLowerCase(),
    },
    // special case for RheumaHelper only
    ru: {
        short: config_1.COUNTRY.RU.toLowerCase(),
        long: 'Russia',
        locale: 'ru-RU',
        language: 'ru',
        languageLong: 'Russian',
        display: 'Russian',
        currency: 'RUB',
        timezone: 'Europe/Moscow',
        apiCountry: config_1.COUNTRY.RU.toLowerCase(),
    },
    es: {
        short: config_1.COUNTRY.ES.toLowerCase(),
        long: 'Spain',
        locale: 'es-ES',
        language: 'es',
        languageLong: 'Spanish',
        display: 'España',
        currency: 'EUR',
        timezone: 'Europe/Madrid',
        apiCountry: config_1.COUNTRY.ES.toLowerCase(),
    },
    fr: {
        short: config_1.COUNTRY.FR.toLowerCase(),
        long: 'France',
        locale: 'fr-FR',
        language: 'fr',
        languageLong: 'French',
        display: 'France',
        currency: 'EUR',
        timezone: 'Europe/Paris',
        apiCountry: config_1.COUNTRY.FR.toLowerCase(),
    },
    pl: {
        short: config_1.COUNTRY.PL.toLowerCase(),
        long: 'Poland',
        locale: 'pl-PL',
        language: 'pl',
        languageLong: 'Polish',
        display: 'Polska',
        currency: 'PLN',
        timezone: 'Europe/Warsaw',
        apiCountry: config_1.COUNTRY.PL.toLowerCase(),
    },
    en: {
        short: config_1.COUNTRY.EN.toLowerCase(),
        long: 'England',
        locale: 'en-EN',
        language: 'en',
        languageLong: 'English',
        display: 'English',
        currency: 'EUR',
        timezone: 'Europe/London',
        apiCountry: config_1.COUNTRY.EN.toLowerCase(),
    },
    hu: {
        short: config_1.COUNTRY.HU.toLowerCase(),
        long: 'Hungary',
        locale: 'hu-HU',
        language: 'hu',
        languageLong: 'Hungarian',
        display: 'Magyarország',
        currency: 'HUF',
        timezone: 'Europe/Budapest',
        apiCountry: config_1.COUNTRY.HU.toLowerCase(),
    },
    zh: {
        short: config_1.COUNTRY.ZH.toLowerCase(),
        long: 'China',
        locale: 'zh-cn',
        language: 'zh',
        languageLong: 'Chinese',
        display: 'China',
        currency: 'CNY',
        timezone: 'Asia/Shanghai',
        apiCountry: 'cn',
    },
    gr: {
        short: config_1.COUNTRY.GR.toLowerCase(),
        long: 'Greece',
        locale: 'el-GR',
        language: 'el',
        languageLong: 'Greek',
        display: 'Ελλάδα',
        currency: 'EUR',
        timezone: 'Europe/Athens',
        apiCountry: config_1.COUNTRY.GR.toLowerCase(),
    },
};
